export enum QuestionResponseType {
    SINGLE_SELECT = "single-select",
    NUMBER = "number",
    DATETIME = "datetime"
}

export enum IICPatternType {
    LPD = "LPD/L-SW",
    GPD = "GPD/G-SW/BIPD",
    LRDA = "LRDA",
    OTHER = "Other (SEDs, GRDA, suppression, burst-suppression, background, etc.)"
}

export enum EBOOSTQuestionID {
    IIC_PATTERN_TYPE = "iic_pattern_type",
    IIC_PATTERN_LOCATION = "iic_pattern_location",
    IIC_PATTERN_PREVALENCE = "iic_pattern_prevalence",
    IIC_PREDOMINANT_FREQUENCY = "iic_pattern_predominant_frequency",
    IIC_MAX_FREQUENCY = "iic_pattern_max_frequency",
    IIC_TIME_OF_MAX_FREQUENCY = "iic_pattern_time_of_max_frequency"
}

export type BaseQuestionResponse = {
    id: string
    type: QuestionResponseType
    label: string
    response?: any
}

export type AnnotationReviews = AnnotationReview[]

export type AnnotationReview = {
    id: number
    annotation_id: number
    review_type_id: number
    user_id: number
    user_email: string
    timestamp: number
    is_complete: boolean
    form: QuestionResponse[]
}

export type SingleSelectResponse = BaseQuestionResponse & {
    type: QuestionResponseType.SINGLE_SELECT
    options: string[]
    response?: string
}

export type NumberResponse = BaseQuestionResponse & {
    type: QuestionResponseType.NUMBER
    minimum: number
    maximum: number
    numDecimals: number
    response?: number
}

export type DateTimeResponse = BaseQuestionResponse & {
    type: QuestionResponseType.DATETIME
    response?: number
}

export type QuestionResponse = SingleSelectResponse | NumberResponse | DateTimeResponse

export const PREVALENCE_OPTIONS = [
    '0 - 10%',
    '11 - 20%',
    '21 - 30%',
    '31 - 40%',
    '41 - 50%',
    '51 - 60%',
    '61 - 70%',
    '71 - 80%',
    '81 - 90%',
    '91 - 100%',
] as const

export const FREQUENCY_OPTIONS = [
    '< 1 Hz',
    '1 - 1.5 Hz',
    '1.5 - 2 Hz',
    '2 - 2.5 Hz',
    '2.5 - 3 Hz',
    '3 - 3.5 Hz',
    '3.5 - 4 Hz',
    '4 - 4.5 Hz',
    '4.5 - 5 Hz',
    '> 5 Hz',
] as const
